module.exports = __webpack_public_path__ + "static/media/logo.23fd1c25.svg";